import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InventoryThresholdOverrideBus extends BaseBus
{
    constructor(data: InventoryThresholdOverrideBus) {
        super(data);
    }

    CID(): any {
        return this.invThresholdOverrideId;
    }
    initialize(data: InventoryThresholdOverrideBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryThresholdOverrideBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }
        this.updateDt = new Date();

    }
    setId(id: any) {
        this.invThresholdOverrideId = id;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    invThresholdOverrideId: string;
    inventoryLocationId: string;
    inventoryId: string;
    minThreshold: number;
    maxThreshold: number;
    supplier: string;
    supplierId: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    partNbr: string;
    get canEdit(): boolean {
        let can: boolean = true;

        ////if ((this.hasId || (this.hasData && this.data.isAdded))) {
        //if (this.rights.MaintainQuotes) {
        //    can = true;
        //}
        ////}

        return can;
    }
}
